export const summaryCards = [
  { label: 'Total Users', value: '1,284', detail: '42 pending approvals' },
  { label: 'Active Brokers', value: '936', detail: '91% token success rate' },
  { label: 'Running Strategies', value: '27', detail: '3 paused globally' },
  { label: 'Critical Alerts', value: '2', detail: '1 kill switch drill overdue' }
];

export const users = [
  {
    id: 1,
    name: 'Arjun Mehta',
    email: 'arjun.mehta@example.com',
    phone: '+91 98765 43210',
    registrationDate: '2026-03-11',
    lastLogin: '2026-04-04 08:45',
    ipAddress: '49.36.120.45',
    status: 'Active',
    approval: 'Approved',
    subscriptionType: 'Yearly',
    subscriptionStart: '2026-01-01',
    subscriptionEnd: '2026-12-31'
  },
  {
    id: 2,
    name: 'Priya Nair',
    email: 'priya.nair@example.com',
    phone: '+91 99887 77665',
    registrationDate: '2026-03-22',
    lastLogin: '2026-04-03 19:20',
    ipAddress: '103.122.90.18',
    status: 'Suspended',
    approval: 'Approved',
    subscriptionType: 'Monthly',
    subscriptionStart: '2026-03-15',
    subscriptionEnd: '2026-04-15'
  },
  {
    id: 3,
    name: 'Vikram Shah',
    email: 'vikram.shah@example.com',
    phone: '+91 98111 23098',
    registrationDate: '2026-04-01',
    lastLogin: 'Never',
    ipAddress: '117.211.64.102',
    status: 'Inactive',
    approval: 'Pending',
    subscriptionType: 'Monthly',
    subscriptionStart: '2026-04-01',
    subscriptionEnd: '2026-05-01'
  }
];

export const brokerConnections = [
  {
    id: 1,
    user: 'Arjun Mehta',
    clientId: 'FYERS-AXK229',
    redirectUrl: 'https://app.example.com/fyers/callback',
    tokenStatus: 'Healthy',
    tokenExpiry: '2026-04-04 18:30',
    lastAuthentication: '2026-04-04 08:31'
  },
  {
    id: 2,
    user: 'Priya Nair',
    clientId: 'FYERS-PLN843',
    redirectUrl: 'https://app.example.com/fyers/callback',
    tokenStatus: 'Expired',
    tokenExpiry: '2026-04-03 16:10',
    lastAuthentication: '2026-04-03 08:00'
  },
  {
    id: 3,
    user: 'Vikram Shah',
    clientId: 'FYERS-VKS551',
    redirectUrl: 'https://app.example.com/fyers/callback',
    tokenStatus: 'Awaiting Setup',
    tokenExpiry: '--',
    lastAuthentication: '--'
  }
];

export const adminBrokerAccount = {
  clientId: 'ADMIN-FYERS-DATA-001',
  tokenStatus: 'Healthy',
  tokenExpiry: '2026-04-04 23:59',
  lastRefresh: '2026-04-04 07:45'
};

export const strategies = [
  {
    id: 1,
    name: 'Momentum Basket',
    assignedUsers: 215,
    status: 'Enabled',
    mode: 'Live'
  },
  {
    id: 2,
    name: 'Expiry Scalper',
    assignedUsers: 172,
    status: 'Paused',
    mode: 'Paper'
  },
  {
    id: 3,
    name: 'Swing Guard',
    assignedUsers: 341,
    status: 'Enabled',
    mode: 'Live'
  }
];

export const riskControls = [
  { label: 'Open Orders', value: 84, tone: 'warning' },
  { label: 'Accounts in Drawdown', value: 11, tone: 'danger' },
  { label: 'Blocked Symbols', value: 4, tone: 'neutral' },
  { label: 'Kill Switch Status', value: 'Armed', tone: 'success' }
];

export const activityFeed = [
  '2 new users are awaiting approval.',
  'Priya Nair requires broker re-authentication.',
  'Global pause enabled for Expiry Scalper.',
  'Admin data token refreshed successfully at 07:45.'
];
